"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _Search = require("@ellucian/react-design-system/core/Search");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["value", "label"];
var DropdownTypeaheadItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var value = props.value,
    label = props.label,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Search.SearchItem, (0, _extends2.default)({
    ref: ref,
    "data-value": value,
    divider: true
  }, rest), label);
});
DropdownTypeaheadItem.muiName = 'DropdownTypeaheadItem';
DropdownTypeaheadItem.displayName = 'DropdownTypeaheadItem';
DropdownTypeaheadItem.propTypes = {
  /**
   * Text of the dropdown item
   */
  label: _propTypes.default.string.isRequired,
  /**
   * The value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]).isRequired,
  /**
   * If `true`, the dropdown item will be disabled, and unselectable.
   */
  disabled: _propTypes.default.bool,
  /**
   * Icon to be displayed to the the left of the text
   */
  LeftIconComponent: _propTypes.default.node,
  /**
   * Icon to be displayed to the the right of the text
   */
  RightIconComponent: _propTypes.default.node
};
DropdownTypeaheadItem.defaultProps = {
  disabled: false,
  LeftIconComponent: null,
  RightIconComponent: null
};
var _default = exports.default = DropdownTypeaheadItem;